import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShaderEffect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconShaderEffect"><Path d="M20.2441 3.71191C20.7095 4.16594 21 4.79846 21 5.5V18.5C21 19.8807 19.8807 21 18.5 21H5.5C4.79846 21 4.16594 20.7095 3.71191 20.2441L20.2441 3.71191Z" fill="currentColor"/><Path d="M18.5 3C18.81 3 19.1059 3.05895 19.3799 3.16211L3.16211 19.3799C3.05895 19.1059 3 18.81 3 18.5V13.207L13.207 3H18.5Z" fill="currentColor"/><Path d="M3 11.793V5.5C3 4.11929 4.11929 3 5.5 3H11.793L3 11.793Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShaderEffect;
